"use client";
import React, { useRef, useEffect } from 'react';
import { ChevronDown, Menu, X } from "lucide-react";
import Image from 'next/image';

const Navbar = () => {
  const [siteOpen, setSiteOpen] = React.useState(false);
  // const [resourcesOpen, setResourcesOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [mobileSiteOpen, setMobileSiteOpen] = React.useState(false);
  // const [mobileResourcesOpen, setMobileResourcesOpen] = React.useState(false);
  const siteRef = useRef<HTMLLIElement>(null);
  // const resourcesRef = useRef<HTMLLIElement>(null);
  const [mounted, setMounted] = React.useState(false);

  useEffect(() => {
    setMounted(true);
    const handleClickOutside = (event: MouseEvent) => {
      if (
        siteRef.current && !siteRef.current.contains(event.target as Node)
        // && resourcesRef.current && !resourcesRef.current.contains(event.target as Node)
      ) {
        setSiteOpen(false);
        // setResourcesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // set initial state

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSiteClick = () => {
    setSiteOpen((open) => {
      // if (!open) setResourcesOpen(false);
      return !open;
    });
  };
  // const handleResourcesClick = () => {
  //   setResourcesOpen((open) => {
  //     if (!open) setSiteOpen(false);
  //     return !open;
  //   });
  // };

  return (
    <header className={`sticky top-0 left-0 w-full z-[99999] p-5 md:p-4 transition-colors duration-300 ${scrolled ? 'bg-white' : 'bg-[#005E60]/100'}`}>
      <nav className="container mx-auto flex items-center justify-between relative">
        <button
          className="md:hidden mr-2"
          onClick={() => setMobileMenuOpen((open) => !open)}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          type="button"
        >
          {mobileMenuOpen ? (
            <X className={`${scrolled ? 'text-[#005E60]' : 'text-white'} w-7 h-7`} />
          ) : (
            <Menu className={`${scrolled ? 'text-[#005E60]' : 'text-white'} w-7 h-7`} />
          )}
        </button>
        <div className="flex-1 flex justify-center md:justify-start mr-8 md:mr-0">
          <Image src={
            !mounted
              ? "/logo1.svg"
              : scrolled
              ? "/whitenavbarlogo.svg"
              : "/logo1.svg"
          } alt="GE Verona Logo" width={220} height={50} className="h-12 w-auto" />
        </div>

        <ul className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 space-x-10">
          <li>
            <a href="#about" className={`${scrolled ? 'text-[#005E60]' : 'text-white'} font-bold text-lg cursor-pointer`}>About</a>
          </li>

          <li className="relative" ref={siteRef}>
            <button
              className={`flex items-center focus:outline-none font-bold text-lg cursor-pointer ${scrolled ? 'text-[#005E60]' : 'text-white'}`}
              onClick={handleSiteClick}
              aria-expanded={siteOpen}
              aria-haspopup="true"
              type="button"
            >
              The Site
              <ChevronDown className={`ml-1 w-4 h-4 transition-transform ${siteOpen ? 'rotate-180' : ''} ${scrolled ? 'text-[#005E60]' : 'text-white'}`} />
            </button>

            {siteOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 mt-4 w-72 bg-white rounded-xl shadow-xl py-6 px-8 flex flex-col space-y-4 z-20">
                <a href="#site" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">Overview</a>
                <a href="#history" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">Our History</a>
                <a href="#heritage" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">The Buildings</a>

              </div>
            )}
          </li>

          {/* <li className="relative" ref={resourcesRef}>
            <button
              className={`flex items-center focus:outline-none font-bold text-lg cursor-pointer ${scrolled ? 'text-[#005E60]' : 'text-white'}`}
              onClick={handleResourcesClick}
              aria-expanded={resourcesOpen}
              aria-haspopup="true"
              type="button"
            >
              Resources
              <ChevronDown className={`ml-1 w-4 h-4 transition-transform ${resourcesOpen ? 'rotate-180' : ''} ${scrolled ? 'text-[#005E60]' : 'text-white'}`} />
            </button>

            {resourcesOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 mt-4 w-72 bg-white rounded-xl shadow-xl py-6 px-8 flex flex-col space-y-4 z-20">
                <a href="#resources" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">The Timeline</a>
                <a href="#intro-heading-project" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">Latest Documents</a>
                <a href="#updates" className="font-bold text-lg text-[#005E60] hover:underline cursor-pointer">Latest Updates</a>

              </div>
            )}
          </li> */}

          <li>
            <a href="#faq" className={`${scrolled ? 'text-[#005E60]' : 'text-white'} font-bold text-lg cursor-pointer`}>FAQ</a>
          </li>
        </ul>

        <div className="hidden md:block w-10" />

        <div
          className={`md:hidden fixed top-[72px] left-0 w-full bg-white z-[99999] transition-all duration-300 overflow-y-auto ${mobileMenuOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0 pointer-events-none'}`}
        >
          <ul className="flex flex-col py-4 px-0 space-y-4">
            <li>
              <a href="#about" className="text-[#005E60] font-bold text-xl text-center block py-2" onClick={() => setMobileMenuOpen(false)}>About</a>
            </li>
            <li>
              <button
                className="w-full flex items-center justify-center font-bold text-xl text-[#005E60] py-2 focus:outline-none"
                onClick={() => {
                  setMobileSiteOpen((open) => {
                    // if (!open) setMobileResourcesOpen(false);
                    return !open;
                  });
                }}
                aria-expanded={mobileSiteOpen}
                aria-controls="mobile-site-dropdown"
                type="button"
              >
                The Site
                <ChevronDown className={`ml-2 w-6 h-6 transition-transform ${mobileSiteOpen ? 'rotate-180' : ''}`} />
              </button>
              <div
                id="mobile-site-dropdown"
                className={`transition-all duration-300 overflow-hidden bg-[#CDE4E4] ${mobileSiteOpen ? 'max-h-[500px] py-6' : 'max-h-0 py-0'}`}
              >
                <ul className="flex flex-col items-center space-y-6">
                  <li>
                    <a href="#site" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>Overview</a>
                  </li>
                  <li>
                    <a href="#history" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>Our History</a>
                  </li>
                  <li>
                    <a href="#heritage" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>The Buildings</a>
                  </li>
                </ul>
              </div>
            </li>
            {/* <li>
              <button
                className="w-full flex items-center justify-center font-bold text-xl text-[#005E60] py-2 focus:outline-none"
                onClick={() => {
                  setMobileResourcesOpen((open) => {
                    if (!open) setMobileSiteOpen(false);
                    return !open;
                  });
                }}
                aria-expanded={mobileResourcesOpen}
                aria-controls="mobile-resources-dropdown"
                type="button"
              >
                Resources
                <ChevronDown className={`ml-2 w-6 h-6 transition-transform ${mobileResourcesOpen ? 'rotate-180' : ''}`} />
              </button>
              <div
                id="mobile-resources-dropdown"
                className={`transition-all duration-300 overflow-hidden bg-[#CDE4E4] rounded-none ${mobileResourcesOpen ? 'max-h-[500px] py-6' : 'max-h-0 py-0'}`}
              >
                <ul className="flex flex-col items-center space-y-6">
                  <li>
                    <a href="#resources" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>The Timeline</a>
                  </li>
                  <li>
                    <a href="#intro-heading-project" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>Latest Documents</a>
                  </li>
                  <li>
                    <a href="#updates" className="text-[#005E60] font-bold text-xl block" onClick={() => setMobileMenuOpen(false)}>Latest Updates</a>
                  </li>
                </ul>
              </div>
            </li> */}
            <li>
              <a href="#faq" className="text-[#005E60] font-bold text-xl text-center block py-2" onClick={() => setMobileMenuOpen(false)}>FAQ</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>

  );
};

export default Navbar;


